<style lang="scss">
.enclose-title {
  line-height: 36px;
  border-bottom: 1px solid #dedede;
  margin-bottom: 16px;
  padding-left: 20px;
  background-color: #19be6b;
  color: #fff;
}
</style>

<template>
  <div>
    <div class="bg-fff margin-top-20 padding-bottom-20">
      <header class="enclose-title font-bold">
        {{
                    $t("erp.b2c.attachment_information", {
                        defaultValue: "附件信息",
                    })
                }}
      </header>
      <Table class="margin-10"
             :columns="columns"
             :data="formList"
             size="small"
             ref="table"
             border
             stripe></Table>
    </div>
    <compAlert v-bind="alertProps"
               @on-alert-close="alertProps.show = false"></compAlert>
  </div>
</template>

<script>
import { mapState } from "vuex";
import compAlert from "../alert/alert.vue";
import { HttpDelAnnex, HttpfindAnnexByOrderId } from "@/service/boss/b2corder";

export default {
  props: ["comEnclosure", "type", "status", "parentId"],
  components: {
    compAlert,
  },
  data () {
    return {
      // formList: []
      alertProps: {
        show: false,
      },
    };
  },
  created () {
    console.log(this.parentId, this.comEnclosure);
    // this.gettablefile();
  },
  computed: {
    formList () {
      return this.comEnclosure || [];
    },
    columns () {
      const _this = this;
      return [
        {
          title: this.$t("erp.b2c.attachment_type", {
            defaultValue: "附件类型",
          }),
          key: "type",
          render (h, { row }) {
            return <div>{row.type}</div>;
          },
        },
        {
          title: this.$t("erp.b2c.attachment_name", {
            defaultValue: "附件名称",
          }),
          key: "name",
          render (h, { row }) {
            return (
              <div>
                <a
                  onClick={_this.downpage.bind(
                    _this,
                    row.url,
                    "url"
                  )}
                >
                  {row.name}
                </a>
              </div>
            );
          },
        },
        {
          title: this.$t("erp.distribution.deliverorderno", {
            defaultValue: "配货单号",
          }),
          key: "deliverOrderNo",
          render (h, { row }) {
            return (
              <div>
                {row.deliverOrderNo ? row.deliverOrderNo : "--"}
              </div>
            );
          },
        },
        {
          width: 100,
          title: this.$t("global.common.operation", {
            defaultValue: "操作",
          }),
          render: (h, { row }) => {
            return (
              <div>
                <Button
                  class="light-content"
                  size="small"
                  type="default"
                  on-click={this.deleteAttach.bind(
                    this,
                    this.parentId,
                    row.commonAttachmentId
                  )}
                >
                  {this.$t("global.common.delete", {
                    defaultValue: "删除",
                  })}
                </Button>
              </div>
            );
          },
        },
      ];
    },
  },
  methods: {
    gettablefile () {
      HttpfindAnnexByOrderId({
        orderId: this.parentId,
        // contextId: 1
      }).then(
        (res) => {
          // console.log(res)
          this.formList = res.data;
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.$VMessage.error({
            content: err.message,
            duration: 30,
            closable: true
          });
        }
      );
    },
    downpage (url) {
      window.open(url, "_blank");
    },
    deleteAttach (orderId, id) {
      this.alertProps = {
        show: true,
        title: this.$t("global.common.delete", {
          defaultValue: "删除",
        }),
        desc: this.$t("erp.product.confirm_delete", {
          defaultValue: `确定删除操作？`,
        }),
        confirm: () => {
          HttpDelAnnex({
            orderId: orderId,
            annexId: id,
          }).then(
            (res) => {
              this.$VMessage.success(res.message);
              this.$emit("on-update");
            },
            (err) => {
              this.$VMessage.error({
                content: err.message,
                duration: 30,
                closable: true
              });
            }
          ).finally(() => {
            this.alertProps.show = false;
          });
        },
      };
    },
  },
};
</script>

